import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import { WavePodiumItem } from "./WavePodiumItem";
interface WaveWinnersPodiumContentProps {
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly firstPlaceWinner?: ApiWaveDecisionWinner | undefined;
  readonly secondPlaceWinner?: ApiWaveDecisionWinner | undefined;
  readonly thirdPlaceWinner?: ApiWaveDecisionWinner | undefined;
}
export const WaveWinnersPodiumContent: React.FC<WaveWinnersPodiumContentProps> = t0 => {
  const $ = _c(13);
  const {
    onDropClick,
    firstPlaceWinner,
    secondPlaceWinner,
    thirdPlaceWinner
  } = t0;
  let t1;
  if ($[0] !== onDropClick || $[1] !== secondPlaceWinner) {
    t1 = <div><WavePodiumItem winner={secondPlaceWinner} onDropClick={onDropClick} position="second" customAnimationIndex={1} /></div>;
    $[0] = onDropClick;
    $[1] = secondPlaceWinner;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== firstPlaceWinner || $[4] !== onDropClick) {
    t2 = <div><WavePodiumItem winner={firstPlaceWinner} onDropClick={onDropClick} position="first" customAnimationIndex={0} /></div>;
    $[3] = firstPlaceWinner;
    $[4] = onDropClick;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== onDropClick || $[7] !== thirdPlaceWinner) {
    t3 = <div><WavePodiumItem winner={thirdPlaceWinner} onDropClick={onDropClick} position="third" customAnimationIndex={2} /></div>;
    $[6] = onDropClick;
    $[7] = thirdPlaceWinner;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = <div className="tw-relative tw-mx-auto tw-rounded-xl tw-overflow-hidden tw-pt-6 lg:tw-px-4 tw-bg-iron-950/60"><div className="md:tw-max-w-3xl tw-mx-auto"><div className="tw-grid tw-grid-cols-3 tw-gap-x-2 lg:tw-gap-x-4 tw-items-end">{t1}{t2}{t3}</div></div></div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};